<div class="section__title">
  <div>
    <!-- <h4 class="pretitle__h4">Administrador</h4> -->
    <h1>Clientes</h1>
  </div>
  <div class="btn-titles">
    <button type="button" [routerLink]="['/admin/client/edit']" class="btn-black">
      <i class="fas fa-plus"></i> Nuevo cliente</button>
  </div>
</div>

<table id="tblclient" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-hover data-tables w-100">
  <thead>
    <tr>
      <th class="text-center text-nowrap w-10">Fecha de alta</th>
      <th data-priority="1">Cliente</th>
      <th class="text-center w-6" data-priority="2">Estado</th>
      <th class="text-center w-6" data-priority="2">Opciones</th>
    </tr>
  </thead>
</table>
